<template>
  <span class="pi-mcell" :title="view.title">
    <span class="pi-mcell__value" :class="{ 'is-muted': !view.visible }">{{ view.text }}</span>
    <span v-if="view.badge" class="pi-badge" :class="'pi-badge--' + view.tone">{{ view.badge }}</span>
    <span v-if="showRatio && view.ratio" class="pi-table__sub">{{ view.ratio }}{{ ratioSuffix ? ' ' + ratioSuffix : '' }}</span>
    <span v-if="view.delta" class="pi-table__sub">{{ view.delta }}</span>
    <span v-if="showReason && view.reason" class="pi-table__sub">{{ view.reason }}</span>
  </span>
</template>

<script>
import { metricCell } from "./piTable.js";

export default {
  name: "pi-metric-cell",
  props: {
    cell: { type: Object, default: null },
    showRatio: { type: Boolean, default: true },
    ratioSuffix: { type: String, default: "" },
    showReason: { type: Boolean, default: true },
  },
  computed: {
    view() {
      return this.cell || metricCell(null);
    },
  },
};
</script>

<style src="./pi.css"></style>

<style scoped>
.pi-mcell {
  display: inline-block;
  min-width: 0;
}

.pi-mcell__value {
  font-weight: 700;
  color: #1f2933;
  margin-right: 4px;
}

.pi-mcell__value.is-muted {
  font-weight: 600;
  color: #6b7280;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piMetricCell.vue